import { Formik, FormikValues } from 'formik'
import React, { PropsWithChildren } from 'react'

interface Props {
  initialValues: FormikValues
  validationSchema: any
  onSubmit: (values: FormikValues) => any
}

const Form: React.FC<PropsWithChildren<Props>> = ({
  initialValues,
  onSubmit,
  validationSchema,
  children,
}) => {
  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={validationSchema}>
      {() => <>{children}</>}
    </Formik>
  )
}

export default Form
